import React from 'react';
import { GROUP_STATUSES, GROUP_STATUS_LABEL } from '../utils/requestGroups';

// Status tabs for the grouped download-request views. `counts` is the
// endpoint's statusCounts ({PENDING, PARTIALLY_APPROVED, APPROVED, REJECTED});
// '' = All.
// TODO(#9 follow-up): the client wants the Partially Approved tab toggleable
// from settings; no configuration flag exists yet, so it is always shown.
function RequestStatusTabs({ value, counts = {}, onChange }) {
    const total = GROUP_STATUSES.reduce((a, k) => a + (Number(counts[k]) || 0), 0);
    const tabs = [{ key: '', label: 'All Requests', count: total }].concat(
        GROUP_STATUSES.map((k) => ({ key: k, label: GROUP_STATUS_LABEL[k], count: Number(counts[k]) || 0 }))
    );
    return (
        <div className="request-status-tabs" role="tablist">
            {tabs.map((t) => (
                <button key={t.key || 'ALL'} type="button" role="tab" aria-selected={value === t.key}
                    className={`btn-tabs ${value === t.key ? 'active' : ''}`}
                    onClick={() => onChange(t.key)}>
                    {t.label}<span className="count">{t.count}</span>
                </button>
            ))}
        </div>
    );
}

export default RequestStatusTabs;
